<template>
  <div>
    <div class="mb-8 font-bold text-3xl">
      <Link
        class="text-indigo-400 hover:text-indigo-600"
        :href="route('eos.index')">
        Verifikasi Akhir Studi
      </Link>
      <span class="font-medium text-indigo-400">/</span> Pilih Calon Penerima
      Akhir Studi
    </div>
    <div class="w-full flex justify-between mb-4">
      <search-filter
        v-model="form.search"
        placeholder="Cari Nama atau NIM..."
        :show-dropdown="false"
        class="flex-shrink-0 w-3/6 max-w-md"
        @reset="reset" />
      <button
        class="btn-indigo"
        :disabled="!selectedCount"
        @click.prevent="confirmRegisterCandidate">
        Daftarkan {{ selectedCount > 0 ? selectedCount : "" }} Mahasiswa ke
        Proses Akhir Studi
      </button>
    </div>
    <div class="overflow-x-scroll bg-white rounded-md shadow">
      <div class="w-full my-2">
        <span class="text-bold text-lg p-4">{{ selectedCount }} data mahasiswa telah dipilih</span>
      </div>
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4 text-center">
              Pilih
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Nama Mahasiswa / NIM
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Kampus
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Kota Studi
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Tahun Masuk Kuliah
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Semester
            </th>
            <th class="px-6 pt-6 pb-4 text-left">
              Jenjang Pendidikan
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in eosRecords.data"
            :key="row.id"
            class="focus-within:bg-gray-100 hover:bg-gray-100">
            <td class="py-4 px-6 text-left border-t">
              <input type="checkbox" v-model="row.selected">
            </td>
            <td class="py-4 px-6 text-left border-t">
              {{ row.mahasiswa_name }}<br><small>{{
                row.mahasiswa_nim
              }}</small>
            </td>
            <td class="py-4 px-6 text-left border-t">
              {{ row.universitas_name }}
            </td>
            <td class="py-4 px-6 text-left border-t">
              {{ row.kota_studi }}
            </td>
            <td class="py-4 px-6 text-left border-t">
              {{ row.college_entry_year }}
            </td>
            <td class="py-4 px-6 text-left border-t">
              {{ row.current_semester }}
            </td>
            <td class="py-4 px-6 text-left border-t">
              {{ row.jenjang_pendidikan }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="eosRecords.links" />
  </div>
</template>

<script lang="js">
import Layout from '@/Shared/Layout'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import { throttle, mapValues, pickBy } from 'lodash'
import { router, Link } from '@inertiajs/vue2'
import Swal from 'sweetalert2'

export default {
  metaInfo: { title: 'Pilih Calon Penerima Akhir Studi'},

  components: {
    SearchFilter,
    Pagination,
    Link,
  },

  props: {
    filters: Object,
    eosRecords: Object,
  },

  layout: Layout,

  computed: {
    selectedCount () {
      return this.eosRecords.data.filter(item => item.selected === true).length
    },
  },

  data () {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },

  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        router.get(this.route('eos_candidate.index'), pickBy(this.form), {
          preserveState: true,
        })
      }, 150),
    },
  },

  methods: {
    closeModal () {
      this.$emit('close')
    },
    reset () {
      this.form = mapValues(this.form, () => null)
    },
    confirmRegisterCandidate ()
    {
      Swal.fire({
          title: 'Konfirmasi',
          text: 'Apakah anda yakin ingin memproses data kandidat Akhir Studi?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
      }).then((result) => {
         if (result.isConfirmed) {
            this.submitCandidate()
         }
      })
    },
    submitCandidate (){
      const selectedIds = this.eosRecords.data.filter(item => item.selected).map(item => item.id)
      router.post('eos_candidate', {
        selectedIds,
      })
    },
  },
}
</script>
